import { Link } from "react-router-dom";
import "./templates.css";

const LINKS = [
  ["/", "Home"],
  ["/pricing", "Pricing"],
  ["/guides", "Guides"],
  ["/compare", "Compare"],
  ["/tools", "Free tools"],
];

/** The catch-all route. Seo.jsx adds the noindex tag for the same path. */
export default function NotFound() {
  return (
    <section className="tpl">
      <div className="container tpl__inner">
        <header className="tpl__head">
          <h1 className="t-display-2">Page not found</h1>
          <p className="t-lead tpl__lead">
            That address does not exist, or the page has moved. Try one of these.
          </p>
        </header>
        <ul className="tpl-related">
          {LINKS.map(([to, label]) => (
            <li key={to}>
              <Link to={to}>{label}</Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
